import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import classNames from 'classnames';

function Slice(props) {
  const {classes, className, wide, ...otherProps} = props;

  const activeClasses = {
    [`${classes.standardSlice}`]: !wide,
  };

  return (
    <div className={classNames(activeClasses, className)} {...otherProps}>
      {props.children}
    </div>
  )

}

export default withStyles((theme) => ({
  standardSlice: {
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up(1024)]: {
      paddingLeft: theme.spacing.unit * 6,
      paddingRight: theme.spacing.unit * 6,
    },
  },
}))(Slice);


// WEBPACK FOOTER //
// ./src/parts/Slice.js